<template>
    <div class="relative">
        <div @click="openPopup($event)" style="display:flex; flex-direction:row; align-items:center; justify-content:center; padding:5px 10px 5px 5px; cursor:pointer">
          <img class="img-function" src="../../public/icone/share.png" >
        </div>

  
      <transition name="fade">
        <div v-if="visible" class="popup" :style="{ top: `${popupCoordinates.y}px`, left: `${popupCoordinates.x}px` }">
            <div class="contenitore-pulsante">
                <button class="close-button" @click.stop="closePopup">X</button>
            </div>
            <div style="padding-bottom:10px; padding-left:5px;">{{ trans[localLanguage]['condividi'] }}</div>
          <a class="singolo-social" href="https://www.facebook.com/TWENTYFIRSTLIVINGART" target="_black">
              <div><img class="img-social" src="../../public/icone/fb-logo.png" ></div>
              <div style="padding: 0px 10px;">Facebook</div>
          </a>
          <a class="singolo-social" href="https://www.instagram.com/21stbyelbi/" target="_black">
            <div><img class="img-social" src="../../public/icone/insta-logo.png" ></div>
            <div style="padding: 0px 10px;">Instagram</div>
          </a>
        </div>
      </transition>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        localLanguage: 'en',
        visible: false,
        popupCoordinates: { x: 0, y: 0 },
        trans: {
            'it': {
            condividi: 'Condividi',
            },
            'en': {
                condividi: 'Share',
            }
        }
      };
    },
    methods: {
      getLanguage() {
        this.localLanguage =  localStorage.getItem('selectedLanguage')
        return localStorage.getItem('selectedLanguage');
    },
      openPopup(event) {
        this.popupCoordinates.x = event.offsetX;
        this.popupCoordinates.y = event.offsetY;
        this.visible = true;
      },
      closePopup() {
        this.visible = false;
      },
    },
  };
  </script>
  
  <style scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  
  .relative {
    position: relative;
  }
  .contenitore-pulsante{
    width:100%;
    display:flex;
    justify-content:flex-end;
    position:absolute;
    top:5px;
    right:10px;
  }
  
  .popup {
    position: absolute;
    background-color: white;
    border: 1px solid black;
    padding: 10px;
    z-index: 100;
    min-width: 170px;
  }
  .close-button{
    background-color:white;
    border:none;
    padding:5px;
    
  }
  .singolo-social{
    display:flex; 
    flex-direction:row;
    justify-content: flex-start;
    align-items:center;
    padding-bottom:10px;
    color:black;
  }
  .img-social{
    max-width:30px;
  }
  </style>
  